<template>
  <div class="storage-damage-wrap">
    <Accordion>
      <template v-slot:body>
        <div class="h5">[비용 규정]</div>
        <div class="pl-2">
          1.	보관료
          <div class="pl-3">A.	계약종료 후 1개월 연장 월 5,000원/박스</div>
          <div class="pl-3">B.	계약종료 후 6개월 연장 월 3,330원/박스</div>
          <div class="pl-3">C.	계약종료 후 1년 연장 월 2,500원/박스</div>

          <div class="pt-2">2.	계약 시 보관용 빈 박스 배송료</div>
          <div class="pl-3">A.	10,000원/박스</div>
          <!--        <div class="pl-3">B.	무료 (이사서비스 이용 시)</div>-->

          <div class="pt-2">3.	계약 시 포장 후 보관박스 픽업료</div>
          <div class="pl-3">A.	10,000원/박스</div>
          <div class="pl-3">B.	무료 (박스 배달 시 5분 내로 짐을 넣어 줄 경우)</div>

          <div class="pt-2">4.	계약 시 배송 취소 수수료</div>
          <div class="pl-3">A.	박스 배송 전: 무료</div>
          <div class="pl-3">B.	박스 배송 후: 10,000원/박스</div>

          <div class="pt-2">5.	보관 중 박스 배달료</div>
          <div class="pl-3">A.	10,000원/박스 (신청 후 2근무일 이후 배송)</div>
          <div class="pl-3">B.	20,000원/박스 (신청 후 다음 근무일내 배송)</div>

          <div class="pt-2">6.	보관박스 계단료 추가</div>
          <div class="pl-3">A.	1,000원/박스 X 층수 (2층 부터 부과, 지상층 기준)</div>
          <div class="pl-3">B.	빈 박스는 무료: 짐이 담기기 전의 빈 박스와 짐을 찾으신 후의 빈박스 운송료는 무료</div>
          <div class="pl-3">C.	계단, 연석, 비탈 등 지리적인 요인으로 대차 이용이 불가 할 경우 그 시작점을 2층으로 간주</div>

          <div class="pt-2">7.	대기 수수료</div>
          <div class="pl-3">A.	고객님이 밥아저씨(또는 밥아저씨 대리인과)와 연락이 닿았을 시, 10분 내 배송 및 수거 등의 스케줄 이행이 가능하면 무료,</div>
          <div class="pl-3">B.	그 이상의 시간부터는 박스당10,000원씩 추가</div>

          <div class="pt-2">8.	보관 중 박스 배송 취소 수수료</div>
          <div class="pl-3">A.	고객님의 취소로 인해 발생</div>
          <div class="pl-5">가)	배송까지 남은 기간 2영업일 전 (전전일): 무료</div>
          <div class="pl-5">나)	배송까지 남은 기간 2영업일 내 (전일): 5,000원/박스</div>
          <div class="pl-5">다)	배송까지 남은 기간 1영업일 내 (당일): 10,000원/박스</div>
          <div class="pl-3">B.	고객님(또는 대리인)의 부재로 인해 발생</div>
          <div class="pl-5">가)	10,000원/박스</div>

          <div class="pt-2">9.	주차 비용</div>
          <div class="pl-3">A.	박스 배달과 회수를 위해 발생한 주차 비용은 고객님 부담</div>

          <div class="pt-2">10.	승강기 비용</div>
          <div class="pl-3">A.	박스 배달과 회수를 위해 발생한 승강기 비용은 고객님 부담</div>

          <div class="pt-2">11.	주말 및 공휴일 배송</div>
          <div class="pl-3">A.	카카오채널로 문의</div>

          <div class="pt-2">12.	계약 종료 시 보관 물품 처분료</div>
          <div class="pl-3">A.	10,000원/박스 (박스 내 물건 미반환)</div>

          <div class="pt-2">13.	계약 종료 시 보관박스 배송료</div>
          <div class="pl-3">A.	10,000원/박스 (박스 배달 시 10분 내로 박스를 돌려줄 경우)</div>
          <div class="pl-3">B.	20,000원/박스 (박스 배달 후 10분 이상 소요될 경우)</div>

          <div class="pt-2">14.	분실 또는 손상된 박스 수수료</div>
          <div class="pl-3">A.	30,000원/박스</div>

          <div class="pt-2">15.	연체료</div>
          <div class="pl-3">A.	정해진 연체 가산금에 따라 청구</div>

          <div class="pt-2">16.	담보 판매/경매 수수료</div>
          <div class="pl-3">A.	미납 기한 60일 지난 후에, 밥아저씨는 해당 물품에 대하여 판매/경매를 할 수 있음</div>
          <div class="pl-3">B.	100,000원/건</div>

          <div class="pt-2">18.	보관료는 밥아저씨가 고객님의 포장된 박스를 수령한 날부터 시작되며 예약진행 시 지불해야 합니다. 계약일 만료 후 날짜가 경과되면 최소 보관 기간(30일) 보관료를 지불해야 합니다.</div>
        </div>


        <div class="h5 pt-4">[보관금지 품목 규정]</div>
        <div class="pl-2">
          1.	인화성 물건은 보관할 수 없습니다.
          <div>인화성 물품은 다음을 포함하지만 이에 국한되지 않습니다:</div>
          <div class="pl-3">A.	네일 리무버, 매니큐어, 아세톤</div>
          <div class="pl-3">B.	소독솜, 알콜솜</div>
          <div class="pl-3">C.	휘발유, 페인트 희석제 및 테레빈 유</div>
          <div class="pl-3">D.	라이터액(액화가스)</div>
          <div class="pl-3">E.	에어로졸 스프레이, 헤어제품, 탈취제, 살충제, 프로판가스, 부탄가스, 향수</div>
          <div class="pl-3">F.	아마인유(LINSEED OIL), 페인트, 도료, 니스, 잉크</div>
          <div class="pl-3">G.	접착제, 염색약, 실리콘 접착제</div>
          <div class="pl-3">H.	배터리</div>
          <div class="pl-3">I.	락스, 세제, 그 외 모든 액상 표백제류</div>
          <div class="pl-3">J.	캠핑용 스토브, 휴대용 가스사용 아이템, 토치, 성냥, 라이터</div>

          <div class="pt-2">2.	기타 금지 물품은 보관할 수 없습니다.</div>
          <div>기타 금지 물품은 다음을 포함하지만 이에 국한되지 않습니다</div>
          <div class="pl-3">A.	화학품, 의약품, 모든 유해 또는 독성 물질</div>
          <div class="pl-3">B.	식품 또는 부패하기 쉬운 모든 종류의 물품</div>
          <div class="pl-3">C.	화기, 모든 종류의 무기 또는 폭약</div>
          <div class="pl-3">D.	모든 종류의 냄새 나 연기를 방출하는 물품</div>
          <div class="pl-3">E.	식물 또는 생물 (살아 있든 죽어 있든지 상관없이)</div>
          <div class="pl-3">F.	액체 또는 압축 가스</div>
          <div class="pl-3">G.	불법 마약, 모조품, 장물 또는 모든 종류의 불법 물품</div>
          <div class="pl-3">H.	정부 기관의 법률이나 규정을 위반하는 개인 재산</div>
          <div class="pl-3">I.	“회사”가 판단하기에 “회사”의 시설과 주변 환경에 있는 사람들의 안전과 건강을 위협하는 모든 항목.</div>
          <div>3.	여권, 운전 면허증, 주민등록증 및 각종 신분증 등의 공식적인 개인 문서 또는 생년월일이나 은행 계좌 번호와 같은 개인 식별 정보가 포함된 어떠한 것도 박스에 넣지 않도록 해야 합니다. 다른 사람의 신원을 도용하는 데 사용할 수 있는 정보가 포함된 서류나 급하게 필요할 수도 있는 문서를 박스에 넣지 않도록 해야 합니다.</div>
        </div>

        <div class="h5 pt-4">[파손, 훼손 규정 및 배상 규정]</div>
        <div class="pl-2">
          1.	박스는 박스 무게를 포함하여 박스당 20Kg을 초과할 수 없습니다.
          <div>2.	고객님은 박스 포장 시 모든 물품을 보호용 포장 자재로 물품을 보호할 책임이 있습니다.</div>
          <div>3.	박스내의 물품을 얼마나 잘 포장했는지에 관계없이 배송 중에 진동이 발생할 수 있습니다. 밥아저씨는 박스 운송에 주의하여 취급하기 위해 모든 예방 조치를 취하지만 실수로 긁히거나 찌그러지거나 하는 약간의 손상 위험이 있습니다. 따라서 보관하기 전에 모든 항목, 특히 유리 그릇, 그릇, 거울, 액자, 악기, 수집품 또는 쉽게 손상될 수 있는 물품과 같은 깨지기 쉬운 물건은 안전하게 포장해야 합니다.</div>
          <div>4.	밥아저씨는 고객님의 물품에 곰팡이가 발생하지 않을 것이라고 보장할 수 없습니다. 본 계약을 이행함으로써 밥아저씨는 고객님의 재산에 대한 곰팡이 또는 곰팡이의 자연적인 성장에 대한 책임이 없음을 이해합니다.</div>
          <div>5.	밥아저씨는 물품을 보관하는 것을 거부할 수 있으며, 그러한 물품의 보관 또는 계속적인 보관이 모든 사람의 안전과 보관 시설 또는 보관 시설에 보관된 기타 다른 물품에 위험을 초래한다고 합리적으로 판단할 경우 언제든지 고객님의 비용으로 물품을 반환할 수 있습니다.</div>
          <div>6.	보관 박스에 물품을 넣음으로써 밥아저씨의 책임으로 판명된 파손에 관한 최대 배상액은 10만원 이내에서 고객님과 협의할 것을 이해합니다.</div>
        </div>

        <div class="h5 pt-4">[배송규정]</div>
        <div class="pl-2">
          1.	배송 시간은 평일 오전 9시부터 오후 5시까지입니다. 주말 및 공휴일의 배송은 불가능합니다. 필요시 카카오채널로 문의 바랍니다.
          <div>2.	고객님은 배송을 수행하기 위해 고객님의 주차장 시설을 적법하게 이용할 수 있도록 해야 합니다. 고객님은 물품을 쉽게 가져갈 수 있도록 쉽게 접근 가능한 1층에서 또는 승강기를 이용할 수 있는 장소에서 배송이 이루어 지도록 해야 합니다. 배송 시 밥아저씨 직원이 계단을 위 또는 아래로 물품을 운반해야 하는 경우 제15조(이용 요금)에 명시된 바와 같이 해당 서비스에 대해 별도의 요금이 부과되며 사전에 이 요금에 대해 문의해야 하는 것은 고객님의 의무 입니다.</div>
          <div>3.	고객님은 배송 중에 밥아저씨의 자산, 직원, 대리인, 하청업자가 기타 물품에 손상이나 부상 또는 상해나 손해를 입히지 않고 감염, 유출, 누출, 연무, 물질의 누출 또는 기타의 확산으로부터 피해가 가지 않도록 물품이 박스에 안전하게 배송 준비가 되어 있는지 확인해야 합니다.</div>
          <div>4.	배송을 요청할 때 반드시 예약을 해야 하며, 고객님 또는 대리인이 예정된 시간에 박스를 수령 또는 발송하기 위해 해당 주소에 있어야 합니다..</div>
          <div class="pl-3">A.	일정 변경 및 취소는 수수료가 부과</div>
          <div class="pl-3">B.	고객님 또는 대리인이 배송 및 픽업 예정시각에 나타나지 않을 경우 배송 실패로 간주되고, 수수료가 부과</div>
          <div>5.	밥아저씨는 배송 자원의 잘못된 할당, 일정 충돌, 악천후 경고, 교통 상황, 밥아저씨의 통제 범위를 벗어나는 모든 사건 또는 불가항력의 결과 등을 포함하여 모든 취소 또는 배송에 대해 책임지지 않습니다.</div>
          <div>6.	보관의 경우 물품 포장을 위한 보관박스가 제공되고 포장된 물품은 오직 밥아저씨가 보관하도록 위탁됩니다. 밥아저씨가 고객님에게서 박스를 픽업할 때, 고객님은 이전에 본인에게 할당된 모든 박스를 돌려주셔야 합니다.</div>
          <div class="pl-3">A.	박스를 잃어버리신 경우, 밥아저씨의 책임이 아닐 시, 박스당 수수료가 부과</div>
          <div class="pl-3">B.	박스 픽업 시 대기 시간이 10분이상 지속될 경우, 밥아저씨는 수수료를 청구</div>
          <div class="pl-3">C.	사용하지 않은 빈 박스를 예정된 포장 박스 픽업 날에 반납하더라도 취소 비용이 부과</div>
          <div>7.	보관의 배송 요구는 1근무일 (영업종료 2시간 전) 전에 통보해야 하며 밥아저씨의 스케줄에 따라 이용할 수 있습니다.</div>
          <div>8.	배송 및 픽업은 밥아저씨 서비스 가능 지역만 이용이 가능합니다.</div>
          <div class="pl-3">A.	물품단위 서비스 가능 지역은 서울 강남구, 송파구, 서초구, 성동구</div>
          <div class="pl-3">B.	고객님이 기존 서비스 지역 주소에서 서비스 불가 지역으로 이전한 경우, 밥아저씨가 직접 배송을 하지 않고, 제3자 업체에서 배송</div>
          <div class="pl-3">C.	비용은 제3자 업체의 가격과 밥아저씨의 배송료를 합산한 비용이 청구</div>
        </div>


        <div class="h5 pt-4">[책임제한 규정]</div>
        <div class="pl-2">
          1.	밥아저씨는 천재지변 또는 이에 준하는 불가항력으로 인하여 "서비스"를 제공할 수 없는 경우에는 "서비스" 제공에 관한 책임이 면제됩니다.
          <div>2.	밥아저씨는 고객님의 귀책사유로 인한 "서비스" 이용의 장애에 대하여는 책임을 지지 않습니다.</div>
          <div>3.	밥아저씨는 고객님이 "서비스"와 관련하여 게재한 정보, 자료, 사실의 신뢰도, 정확성 등의 내용에 관하여는 책임을 지지 않습니다.</div>
          <div>4.	밥아저씨는 고객님 간 또는 고객님과 제3자 상호간에 "서비스"를 매개로 하여 거래 등을 한 경우에는 책임이 면제됩니다.</div>
          <div>5.	밥아저씨는 무료로 제공되는 서비스 이용과 관련하여 관련법에 특별한 규정이 없는 한 책임을 지지 않습니다.</div>
          <div>6.	밥아저씨는 제3자가 서비스 내 화면 또는 링크된 웹 사이트를 통하여 광고한 제품 또는 서비스의 내용과 품질에 대하여 감시할 의무 기타 어떠한 책임도 지지 아니합니다.</div>
          <div>7.	밥아저씨 및 밥아저씨의 임직원 그리고 대리인은 아래와 같은 사항으로부터 발생하는 손해에 대해 책임을 지지 아니합니다.</div>
          <div class="pl-3">A.	고객님 상태정보의 허위 또는 부정확성에 기인하는 손해</div>
          <div class="pl-3">B.	그 성질과 경위를 불문하고 "서비스"에 대한 접속 및 "서비스"의 이용과정에서 발생하는 개인적인 손해</div>
          <div class="pl-3">C.	서버에 대한 제3자의 모든 불법적인 접속 또는 서버의 불법적인 이용으로부터 발생하는 손해</div>
          <div class="pl-3">D.	서버에 대한 전송 또는 서버로부터의 전송에 대한 제3자의 모든 불법적인 방해 또는 중단행위로부터 발생하는 손해</div>
          <div class="pl-3">E.	제3자가 "서비스"를 이용하여 불법적으로 전송, 유포하거나 또는 전송, 유포되도록 한 모든 바이러스, 스파이웨어 및 기타 악성 프로그램으로 인한 손해</div>
          <div class="pl-3">F.	전송된 데이터의 오류 및 생략, 누락, 파괴 등으로 발생되는 손해</div>
          <div class="pl-3">G.	고객님 간의 "서비스" 이용 과정에서 발생하는 명예훼손 기타 불법행위로 인한 각종 민형사상 책임</div>

          <div class="pt-2">8.	밥아저씨는 회사에서 규정한 보상 범위 외에는 책임지지 않습니다. 또한 씰이 파손되거나 잠금 장치가 파손된 경우도 포함합니다.</div>
          <div>9.	고객님은 본 웹 사이트 및 서비스를 사용 시 전적으로 고객님의 책임임을 인지해야 합니다. 고객님이 웹사이트의 내용을 잘못 이해한 경우 밥아저씨는 어떠한 책임을 지지 않습니다.</div>
          <div>10.	고객님은 보관금지 품목 규정과 파손, 훼손 규정 및 배상 규정에 따라서 물품의 파손이나 분실에 대하여 밥아저씨는 어떠한 경우에도 책임을 지지 않습니다.</div>
          <div>11.	어떠한 경우에도 보험 청구의 여부와 관계없이 모든 품목, 상자 및 물품에 대한 밥아저씨의 총 책임은 (i) 분실 또는 손상된 물품의 비용; (ii) 청구일 현재의 재화의 교체 비용 또는 (iii) 해당 품목, 상자 또는/그리고 물품에 대한 최대 100,000원 보험보상금의 그 이하를 초과하지 않습니다. 보험 청구의 경우, 밥아저씨는 손실 혐의 및 손해의 증거 및 분실 또는 손상된 제품의 교체 또는 초기 비용을 청구할 권리가 있습니다.</div>
          <div>12.	보험 청구 경우에 밥아저씨는 박스 및/또는 보관된 물품의 내용물에 대한 원가 및 현재 교체 비용의 증거를 요구할 권리가 있습니다.</div>
        </div>


        <div class="h5 pt-4">[계약 해지]</div>
        <div class="pl-2">
          1.	고객님은 밥아저씨에 위탁한 고객님의 물품에 대해 반환을 요청하고 밥아저씨의 미지급 금액을 모두 결제함으로 본 계약을 언제든 해지할 수 있습니다.
          <div>2.	고객님이 본인의 물품을 받은 뒤 밥아저씨에서 제공한 박스는 ‘회사’에 다시 반납이 되어야 계약이 종료됩니다.</div>
          <div>3.	밥아저씨는 고객님에게 30일 이전에 사전에 등록한 연락 수단으로 통지 시 해당 계약을 해지할 수 있습니다. 이 경우 밥아저씨는 선 지급된 사용료를 고객님에게 기사용한 보관 비용을 제외하고 반환합니다.</div>
          <div>4.	보관비용은 할인 전 금액을 적용하며 할인 전 금액이 기지불한 금액보다 높을 경우 추가요금 없이 계약대로 해지할 수 있습니다.</div>
          <div>5.	아래와 같은 경우 밥아저씨는 고객님에게 사전에 등록한 연락 수단으로 통보하며 해당 계약을 종료시킬 수 있습니다.</div>
          <div class="pl-3">A.	납부 기일까지 지불해야 할 금액이 지불되지 않은 경우;</div>
          <div class="pl-3">B.	고객님이 해당 계약의 조건 및 조항을 위반할 경우.</div>

          <div class="pt-2">6.	계약의 해지 시 고객님의 비용으로 고객님의 물품 반환을 주선하기 위해 고객님이 밥아저씨에 연락을 해야 하며, 반환은 통보 일로부터 15일이내에 실행되어야 합니다. 고객님은 담보 판매/경매 조항에 따라 밥아저씨가 처분 한 물품에 대해 수령하지 못할 수 있습니다.</div>
          <div>7.	고객님께 연락이 불가할 경우, 처분통지를 하고 계약 만료 후 60일이 경과하면 처분을 하게 되며 경매를 통한 처분일 경우 경매수수료 100,000원이 발생합니다.</div>
        </div>


      </template>
      <template v-slot:header>
        <div class="desc">
          <Checkbox :style="'v2'" id="damage" v-model:checked="agreement">보관 서비스 이용 규정을 확인하였습니다.</Checkbox>
        </div>
      </template>
    </Accordion>

  </div>
</template>

<script>
import Accordion from "@/components/Accordion";
import Checkbox from "@/components/Checkbox";
export default {
  name: "TheEstimateStorageDamage",
  data() {
    return {
      agreement: false
    }
  },
  components: {
    Checkbox,
    Accordion
  },
  methods: {
    isValid() {
      return this.agreement
    }
  }
}
</script>


<style lang="scss" scope>
.storage-damage-wrap {

  .h5 {
    font-size: 0.9rem;
    font-weight: bold;
  }

  .pl-2 > div {
    display: block;
  }
}
</style>
<style lang="scss">
.storage-damage-wrap {
  .btn-icon {
    right: 5px;
  }

  .accordion-header {
    padding-top: 10px;
    padding-bottom: 10px;
    padding-left: 0;
    border-bottom: 0;

    .btn-icon {
      background-color: transparent;
    }
  }
  .accordion-body {
    padding-left: 0;
    padding-right: 0;
    font-size: 0.8rem;
  }

  .accordion-item.open {
    .accordion-header {
      padding-bottom: 25px;
    }

    .accordion-body {
      border-top: 1px solid #c9c9c9;
      max-height: 200px;
      padding-left: 10px;
      padding-right: 10px;
    }
  }

  @include respond(mobile) {
    .accordion-header {
      font-size: 13px;

      .checkbox-group label span {
        font-size: 13px;
      }
    }
  }
}
</style>
